import React from 'react';
import {
  VStack,
  Box,
  Heading,
  Text,
  Image,
  useBreakpointValue,
} from 'native-base';

const title = 'You’re in the right place!';
const subtitle =
  'Ayble is designed to help people like you manage your gut health. With Ayble, you will receive:';

const bullets = [
  'Nutrition program to identify foods that trigger symptoms',
  'Mind-Gut program to help calm your mind and gut',
  'Dedicated health coach access anytime, from anywhere',
  'Gut health tracker to see symptoms change over time',
  'Barcode scanner to remove guesswork at grocery stores',
  'Curated educational content tailored to your interests',
];
const heroImg = './../2screenshots.png';
const backgroundTexture = './../web-bg-texture2.svg';

const backgroundTextureStyle = {
  width: '100%',
  height: '100%',
  resizeMode: 'cover',
  position: 'absolute',
  right: 60,
  top: 35,
};

// 5_see_if_eligible_page
const TransitionGoal = () => {
  const isMobile = useBreakpointValue({ base: true, lg: false });

  return (
    <VStack
      alignItems={'center'}
      space={3}
      className="other-info-container"
      maxW={'100%'}
      testID={'transitional-goal'}
    >
      <Heading fontSize={'3xl'} mb={'0'}>
        {title}
      </Heading>

      <Heading fontFamily="body" fontWeight={'300'} size={'md'} pb={5}>
        {subtitle}
      </Heading>

      <VStack
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={isMobile ? 'column' : 'row'}
      >
        <Box mt={3} pr={isMobile ? '0' : '50'}>
          <ul>
            {bullets.map((bullet, index) => (
              <VStack key={index} mb={10}>
                <li>
                  <Text fontFamily="body" fontSize={'xl'} fontWeight={400}>
                    {bullet}
                  </Text>
                </li>
              </VStack>
            ))}
          </ul>
        </Box>
        <Box position={'relative'} pb={isMobile ? 10 : 0} zIndex={0}>
          <Image
            alt={'hero image'}
            resizeMode="contain"
            size={['xs', 'sm', 'md', 'md', 'md', 'md']}
            source={{
              uri: heroImg,
            }}
            style={{ transform: [{ rotate: '5deg' }], zIndex: 1 }}
            testID={'transitional-goal-image'}
          />
          <Image
            size={'md'}
            style={backgroundTextureStyle}
            source={{
              uri: backgroundTexture,
            }}
            alt="image"
          />
        </Box>
      </VStack>
    </VStack>
  );
};

export default TransitionGoal;
